var _path, _path2, _g, _path3, _path4, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChallengesEmpty = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.0497 50.084C89.7157 51.9092 92.2238 53.9965 94.5343 56.3293C103.698 65.5814 109.038 77.9729 109.526 91M28.5653 50.7065C26.2294 52.3794 24.0216 54.2576 21.9696 56.3293C12.8782 65.5085 7.5507 77.7775 6.99023 90.6918",
    stroke: "#C4B5FD",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.693 92.4412C102.35 92.4412 103.703 91.0963 103.594 89.443C102.87 78.4861 98.196 68.1219 90.3835 60.3094C81.8617 51.7875 70.3035 47 58.2518 47C46.2 47 34.6418 51.7875 26.12 60.3094C18.3075 68.1219 13.6335 78.4861 12.9095 89.443C12.8002 91.0963 14.1537 92.4412 15.8105 92.4412L58.2518 92.4412H100.693Z",
    fill: "#7F39FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9632_1806)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.75,
    y: 19.3916,
    width: 76.1077,
    height: 50,
    rx: 2,
    transform: "rotate(90 82.75 19.3916)",
    fill: "#7F39FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.75,
    y: 19.3916,
    width: 76.1077,
    height: 50,
    rx: 2,
    transform: "rotate(90 82.75 19.3916)",
    fill: "url(#paint0_linear_9632_1806)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.75 19L76.75 95.5",
    stroke: "#18181B",
    strokeWidth: 4,
    strokeDasharray: "8 5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.75 19L38.75 95.5",
    stroke: "#18181B",
    strokeWidth: 4,
    strokeDasharray: "8 5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_9632_1806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5079 55.9862L63.0177 54.8701C63.2861 59.3741 64.699 65.0169 66.9595 69.1578H48.042C50.3025 65.0169 51.7153 59.3741 51.9838 54.8701L57.5079 55.9862Z",
    fill: "url(#paint1_linear_9632_1806)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5079 55.9862L63.0177 54.8701C63.2861 59.3741 64.699 65.0169 66.9595 69.1578H48.042C50.3025 65.0169 51.7153 59.3741 51.9838 54.8701L57.5079 55.9862Z",
    fill: "url(#paint2_linear_9632_1806)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.4947 27C93.4947 43.1014 77.4873 56.1734 57.7835 56.1734C38.0797 56.1734 22.0723 43.1014 22.0723 27H93.4947Z",
    fill: "url(#paint3_linear_9632_1806)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.4947 27C93.4947 43.1014 77.4873 56.1734 57.7835 56.1734C38.0797 56.1734 22.0723 43.1014 22.0723 27H93.4947Z",
    fill: "url(#paint4_linear_9632_1806)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9112 37.5831C16.788 37.5831 19.1202 35.2509 19.1202 32.3741C19.1202 29.4972 16.788 27.165 13.9112 27.165C11.0343 27.165 8.70215 29.4972 8.70215 32.3741C8.70215 35.2509 11.0343 37.5831 13.9112 37.5831Z",
    fill: "url(#paint5_linear_9632_1806)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9112 37.5831C16.788 37.5831 19.1202 35.2509 19.1202 32.3741C19.1202 29.4972 16.788 27.165 13.9112 27.165C11.0343 27.165 8.70215 29.4972 8.70215 32.3741C8.70215 35.2509 11.0343 37.5831 13.9112 37.5831Z",
    fill: "url(#paint6_linear_9632_1806)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.72 37.5831C104.597 37.5831 106.929 35.2509 106.929 32.3741C106.929 29.4972 104.597 27.165 101.72 27.165C98.8429 27.165 96.5107 29.4972 96.5107 32.3741C96.5107 35.2509 98.8429 37.5831 101.72 37.5831Z",
    fill: "url(#paint7_linear_9632_1806)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.72 37.5831C104.597 37.5831 106.929 35.2509 106.929 32.3741C106.929 29.4972 104.597 27.165 101.72 27.165C98.8429 27.165 96.5107 29.4972 96.5107 32.3741C96.5107 35.2509 98.8429 37.5831 101.72 37.5831Z",
    fill: "url(#paint8_linear_9632_1806)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.8807 74.084C75.8807 71.2654 73.5919 68.9795 70.7805 68.9795C63.886 68.9795 51.6793 68.9795 44.7848 68.9795C41.9733 68.9795 39.6846 71.2654 39.6846 74.084C39.6846 79.3735 39.6846 86.8727 39.6846 86.8727H75.8807V74.084Z",
    fill: "url(#paint9_linear_9632_1806)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.8807 74.084C75.8807 71.2654 73.5919 68.9795 70.7805 68.9795C63.886 68.9795 51.6793 68.9795 44.7848 68.9795C41.9733 68.9795 39.6846 71.2654 39.6846 74.084C39.6846 79.3735 39.6846 86.8727 39.6846 86.8727H75.8807V74.084Z",
    fill: "url(#paint10_linear_9632_1806)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.679 98.0241C87.679 91.5252 82.4093 86.2568 75.9104 86.2568C65.4274 86.2568 50.1408 86.2568 39.6436 86.2568C33.1447 86.2568 27.875 91.5252 27.875 98.0241C27.875 98.0269 27.875 98.0269 27.875 98.0269H87.679V98.0241Z",
    fill: "url(#paint11_linear_9632_1806)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.679 98.0241C87.679 91.5252 82.4093 86.2568 75.9104 86.2568C65.4274 86.2568 50.1408 86.2568 39.6436 86.2568C33.1447 86.2568 27.875 91.5252 27.875 98.0241C27.875 98.0269 27.875 98.0269 27.875 98.0269H87.679V98.0241Z",
    fill: "url(#paint12_linear_9632_1806)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9632_1806",
    x: 28.75,
    y: 19.3916,
    width: 58,
    height: 84.1074,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9632_1806"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9632_1806",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_9632_1806",
    x: 2.70215,
    y: 25,
    width: 110.227,
    height: 83.0273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9632_1806"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9632_1806",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9632_1806",
    x1: 65.7279,
    y1: 42.6416,
    x2: 114.935,
    y2: 50.1946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EADEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E4BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9632_1806",
    x1: 72.6521,
    y1: 54.8701,
    x2: 53.4389,
    y2: 58.5038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE11B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFDD1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC61B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9632_1806",
    x1: 39.9097,
    y1: 58.2355,
    x2: 67.1367,
    y2: 58.7944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D38F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6B800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9632_1806",
    x1: 114.987,
    y1: 27,
    x2: 48.0403,
    y2: 50.4111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE11B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFDD1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC61B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9632_1806",
    x1: -12.7207,
    y1: 35.9855,
    x2: 28.1379,
    y2: -0.08772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.30612,
    stopColor: "#7D38F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6B800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9632_1806",
    x1: 22.2552,
    y1: 27.165,
    x2: 11.5149,
    y2: 28.6992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE11B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFDD1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC61B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9632_1806",
    x1: 8.49902,
    y1: 40,
    x2: 19.999,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D38F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6B800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9632_1806",
    x1: 110.064,
    y1: 27.165,
    x2: 99.3235,
    y2: 28.6992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE11B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFDD1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC61B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9632_1806",
    x1: 94.999,
    y1: 36.5,
    x2: 103.999,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D38F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6B800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_9632_1806",
    x1: 86.7727,
    y1: 68.9795,
    x2: 51.63,
    y2: 79.1339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE11B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFDD1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC61B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_9632_1806",
    x1: 34.499,
    y1: 79,
    x2: 61.3782,
    y2: 63.7091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D38F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6B800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_9632_1806",
    x1: 105.675,
    y1: 86.2568,
    x2: 64.4686,
    y2: 116.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE11B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFDD1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC61B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_9632_1806",
    x1: 19.999,
    y1: 101,
    x2: 33.0004,
    y2: 70.5031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D38F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6B800"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChallengesEmpty);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/challenges_empty.6d5136a165f0f03fd7c8619cec9ca6e1.svg";